import React from "react";
import { Navigate, Routes, Route, useLocation } from "react-router-dom";

import routers from "./routers";

import AppLayout from "../Components/AppLayout/Layout/layout";

const useRouteChange = () => {
  const location = useLocation();

  return location.pathname;
};

export const RoutedContent = () => {
  const pathName = useRouteChange();
  const location = useLocation();

  const isUserAuthenticated = () => localStorage.getItem("uniqueKey");

  return (
    <AppLayout>
      <Routes>
        {routers.map((route, index) => (
          <Route
            key={index}
            path={route.path}
            element={
              route.path === "/home" ? (
                <Navigate
                  to={{
                    pathname: "/",
                    search: location.search,
                    hash: location.hash,
                  }}
                  state={location.state}
                  replace
                />
              ) : route.isPrivate && !isUserAuthenticated() ? (
                <Navigate to="/login" replace />
              ) : (
                <route.component />
              )
            }
          />
        ))}
      </Routes>
    </AppLayout>
  );
};

export default RoutedContent;
